// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VModal from "vue-js-modal";

import App from "./App";
import router from "./router";
import store from "./store/index.js";
import util from "./mixins/globalUtilityMixin";
import MixpanelMixin from './mixins/MixpanelMixin'
import VueFroala from "./vue-froala"
Vue.use(VueFroala);
window.VueFroala = VueFroala;

import {
  library
} from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faEllipsisV,
  faCog,
  faComment,
  faTimes,
  faSearch,
  faCircle,
  faInfo,
  faExternalLinkAlt,
  faExclamationTriangle,
  faCheckCircle,
  faFile,
  faEnvelope,
  faLink
} from "@fortawesome/free-solid-svg-icons";

import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";

import { faComment as farComment } from "@fortawesome/free-regular-svg-icons";

require("../static/style.css");
require("../node_modules/bootstrap/dist/css/bootstrap.css");

// Require Froala Editor js file.
require("froala-editor/js/froala_editor.pkgd.min");
require("froala-editor/js/plugins/file.min.js");
require("froala-editor/css/plugins/file.css");

// Require Froala Editor css files.
require("froala-editor/css/froala_editor.pkgd.min.css");

require("font-awesome/css/font-awesome.css");
require("froala-editor/css/froala_style.min.css");
require("../src/custom_module/plugins/css/froala-bootstrap-grid.plugin.css");
require("../static/style.css");
require('froala-editor/css/froala_style.min.css')
require ('../src/custom_module/plugins/css/froala-bootstrap-grid.plugin.css')
require ('../src/custom_module/plugins/js/froala-bootstrap-grid.plugin.js')

library.add(faHome, faEllipsisV, faCog, faComment, faTimes, faSearch, faCircle, faExternalLinkAlt, faInfo,faExclamationTriangle, faCheckCircle, faFile, farComment, faEnvelope, faLink);

Vue.mixin(util);
Vue.mixin(MixpanelMixin);
Vue.use(VModal, {
  dynamic: true
});
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers)


Vue.config.ignoredElements = ["help-hub-header", "help-hub-user-profile",  "employee-hub-service", "enterprise-search"];



/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js